'use strict';

export default class ActivateSuiteWebaccessController {
  errors = {
    forgot: undefined
  };
  submitted = false;

  /*@ngInject*/
  constructor($state, $stateParams, IntegrationService, dialogs, Config) {

    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.IntegrationService = IntegrationService;
    this.dialogs = dialogs;

    IntegrationService.suiteGetWebAccessEmail({webaccessId: $stateParams.webaccessId, token: $stateParams.token}, wa => {
      this.wa = wa;
      this.wa.token = $stateParams.token;
      this.wa.password = '';
      this.wa.confirmPassword = '';
    });
  }

  submit(form) {
    this.submitted = true;

    if(form.$valid) {
      this.IntegrationService.suiteActivatedWebAccess({webaccessId: this.wa._id},{
        email: this.wa.email,
        password: this.wa.password,
        token: this.wa.token
      }, user => {
        let dlg = this.dialogs.notify("Account Activated", "You have successfully activated your account.<br/>You can now login with your email and password.");
        dlg.result.then(() => {
          this.$state.go("login");
        }, () => {
          this.$state.go("main");
        });
      },
        err => {
          alert(err.message);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/activate-suite-webaccess/activate-suite-webaccess.controller.js